'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.hookFunction = void 0;
var tslib_1 = require("tslib");
function hookFunction(oldFunction, newFunction) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        newFunction.call.apply(newFunction, tslib_1.__spreadArray([this], args));
        if (oldFunction) {
            return oldFunction.call.apply(oldFunction, tslib_1.__spreadArray([this], args));
        }
    };
}
exports.hookFunction = hookFunction;
